import script from "./ClientDeviceMonitorSystemMonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDeviceMonitorSystemMonitor.vue?vue&type=script&setup=true&lang=js"

import "./ClientDeviceMonitorSystemMonitor.vue?vue&type=style&index=0&id=2fa296df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa296df"]])

export default __exports__